<template>
  <div>
    <div class="max-w-xl my-0 mx-auto mt-10 px-4 lg:px-0">
      <div v-html="search_title"></div>
      <div>
        <div :class="dynamic_class">
          <div v-html="featured_companies_msg"></div>
          <div :class="loop_class" v-for="(company, index) in companies_data.data" :id="`lc-company${company.id}`"
               :key="index">
            <div class="listing-card border-2 border-solid border-transparent max-w-xl">
              <div
                  class="flex flex-col md:flex-row items-center md:py-0 md:mb-0 p-6 md:p-0 md:pr-6 lg:pr-10 md:min-h-136">
                <a :href="`companies/${company.slug}?tab=jobs&${search_slug}`" :title="company.name"
                   class="p-0 md:pl-6 md:py-8 md:pr-0 lg:pl-10 flex-1 w-full md:w-auto company-card">
                  <div class="md:flex md:items-center flex-1">
                    <div class="mb-4 md:mb-0 flex items-center">
                      <img
                          class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest lazyload"
                          :data-src="company.logo"
                          :alt="`${company.name} Logo`"
                          :title="`${company.name} Logo`"
                      />
                      <div class="text-lg text-primary-darker font-medium ml-6 md:hidden company-name">{{
                          company.name
                        }}
                      </div>
                    </div>
                    <div class="flex md:flex-col items-center md:items-start md:flex-1 mb-8 md:mb-0 md:ml-8 md:mr-2">
                      <div class="text-lg text-primary-darker font-medium hidden md:block md:mb-10px company-name">
                        {{ company.name }}
                      </div>
                      <div class="flex w-full">
                        <div class="text-sm text-onyx-lightest font-semibold w-1/2 md:max-w-1/2 flex">
                          <vs-icon class="text-lg" icon="icon-briefcase" icon-pack="feather"></vs-icon>
                          <p class="ml-10px">{{ company.jobs_count }} Open Job{{company.jobs_count > 1 ? 's' : ''}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <div
                    class="w-full md:w-30p lg:w-23p md:border-0 md:border-l md:border-chrome-lightest md:border-solid md:pl-6 md:py-6">
                  <a :title="`${company.name} Jobs`" :href="`companies/${company.slug}?tab=jobs&${search_slug}`">
                    <primary-button class="mb-2 w-full"> Open Jobs</primary-button>
                  </a>
                  <a :title="`About ${company.name}`" :href="`companies/${company.slug}`" target="_blank">
                    <flat-button class="font-medium w-full" dark>
                      <building-icon></building-icon>
                      About
                    </flat-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="companies_data.last_page > 1" class="mt-5">
        <pagination :data-set="companies_data" :data-param="full_url"></pagination>
      </div>
    </div>
  </div>
</template>

<script>

import event from "../event";
import axios from "axios";

export default {
  name: 'company-result',
  props: {
    companies: {
      type: Array,
      required: false,
    },
    searchTitle: {
      type: String,
      required: false,
    },
    searchSlug: {
      type: String,
      required: false,
    },
    dynamicClass: {
      type: String,
      required: false,
    },
    featuredCompaniesMsg: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      companies_data: this.companies,
      search_title: this.searchTitle,
      search_slug: this.searchSlug,
      dynamic_class: this.dynamicClass,
      featured_companies_msg: this.featuredCompaniesMsg,
      full_url: '',
      loop_class: '',
    }
  },
  mounted() {
    this.filterCompanies(window.location.href);
    let vm = this;
    event.bus.$on('selected-company-filter', function (url) {
      vm.filterCompanies(url);
    });
  },
  methods: {
    filterCompanies(url) {

      this.companies_data = [];
      this.search_title = this.featured_companies_msg = '';
      this.search_title = '<div class="flex justify-center items-center"><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>';
      url = url.indexOf('is_ajax=1') === -1 ? (url.indexOf('?') === -1 ? url + '?is_ajax=1' : url + '&is_ajax=1') : url;

      axios.get(url)
          .then(({data}) => {
            this.companies_data = data.companies;
            this.search_title = data.title;
            this.search_slug = data.searchSlug;
            this.dynamic_class = data.dynamicClass;
            this.featured_companies_msg = data.featuredCompaniesMsg;
            this.full_url = data.fullUrl;
            this.loop_class = (this.dynamic_class == '') ? 'py-2' : '';
          });
    }
  }
}

</script>